import React, { useState, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import { routerUpdatePath } from "../store/root/rootActions";
import updateArray from "../hooks/updateArray";
import { lazy } from "@loadable/component";
import NavBar from "../components/NavBar";
import Home from "../features/home";
import ColorPicker from "../components/ColorPicker";
import ScrollReveal from "scrollreveal";

const SideBar = lazy(() => import("../components/SideBar"));
const About = lazy(() => import("../features/about"));
const Skills = lazy(() => import("../features/skills"));
const Work = lazy(() => import("../features/work"));
const Contact = lazy(() => import("../features/contact"));
const Footer = lazy(() => import("../components/footer"));
const WorkExperience = lazy(() => import("../features/workExperience"));

const RouterConfig = () => {
  const dispatch = useDispatch();
  const routerPath = useSelector((state) => state.root.routerPath);
  const activeColor = useSelector((state) => state.root.activeColor);
  const skills = useSelector((state) => state.root.skills);
  const [show, setShow] = useState(false);

  const setAccordian = () => {
    setShow(!show);
  };

  const activeClass = (link) => {
    const { copyData } = updateArray(routerPath, link);
    dispatch(routerUpdatePath(copyData));
    show && setAccordian();
  };

  // const sr = ScrollReveal({
  //   origin: "top",
  //   distance: "80px",
  //   duration: 1200,
  //   reset: true,
  // });
  // sr.reveal(".home__title", {});
  // sr.reveal(".button", { delay: 200 });
  // sr.reveal(".home__img", { delay: 400 });
  // sr.reveal(".home__social-icon", { interval: 200 });
  // sr.reveal(".about__img", {});
  // sr.reveal(".about__subtitle", { delay: 400 });
  // sr.reveal(".about__text", { delay: 400 });
  // sr.reveal(".skills__subtitle", {});
  // sr.reveal(".skills__text", {});
  // sr.reveal(".skills__data", { interval: 200 });
  // sr.reveal(".skills__img", { delay: 400 });
  // sr.reveal(".work__img", { interval: 200 });
  // sr.reveal(".contact__input", { interval: 200 });

  return (
    <>
      <NavBar
        setShow={setAccordian}
        show={show}
        activeColor={activeColor}
        activeClass={activeClass}
        NavData={routerPath}
      />
      <Home activeColor={activeColor} />
      <ColorPicker show={show} activeColor={activeColor} />
      <Suspense fallback={<div>Loading...</div>}>
        <SideBar
          show={show}
          activeColor={activeColor}
          activeClass={activeClass}
          NavData={routerPath}
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <About activeColor={activeColor} />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <Skills activeColor={activeColor} skills={skills} />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <WorkExperience activeColor={activeColor} />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <Work activeColor={activeColor} />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <Contact activeColor={activeColor} />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <Footer activeColor={activeColor} />
      </Suspense>
    </>
  );
};

export default React.memo(RouterConfig);
